import React, { useContext } from 'react';
import styled from 'styled-components/macro';

import PlayerContext from '@mirinae/lessons/modules/contexts/player';
import Element from '@mirinae/lessons/components/lesson/elements/Element';
import { UserAgent } from '@mirinae/js-utils';

const isMobile = !UserAgent.os.isOthers;

const Img = styled.img`
    width: ${props => props.geom.width}px;
    height: ${props => props.geom.height}px;
    object-fit: cover;
`;

const Image = ({ element, children }) => {
    const player = useContext(PlayerContext);
    const geom = isMobile && element.mobile ? element.mobile.geom : element.geom;

    return (
        <Element element={element}>
            <Img geom={geom} src={player.fieldValue(element, 'url')} />
            {children}
        </Element>
    );
};

export default Image;
